import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Registar.css";
import AboutBanner from "../AboutBanner/AboutBanner";
import { trackEvent, trackPageView } from "../../utils/tracking";

function Registar() {
  const [pathname, setPathName] = useState("");

  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/AboutUs/Registrar",
      "jmf_about-us_registrar"
    );
    // trackPageView("http://localhost:710/AboutUs", "jmf_about-us");

    trackEvent({
      category: "Dynamic Page",
      action: "Registrar Page Loaded",
      label: "jmf_about-us_registrar",
      // value: 1,
    });
  }, []);
  
  useEffect(() => {
    const pathname = window.location.pathname;
    const lastSegment = pathname.slice(pathname.lastIndexOf("/") + 1);
    const CategoryIdUrlid = lastSegment;
    setPathName(CategoryIdUrlid);
  });
  return (
    <>
      <AboutBanner />
      <section className="trustee-sc sponsor-sc">
        <Container>
          <Row>
            <Col sm={12}>
              <ul className="navigator-arrow">
                <li>
                  <a href="/" aria-label="Home">
                    <i class="fa fa-home" aria-hidden="true"></i>
                  </a>{" "}
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                <li>
                  <a href="/AboutUs">
                    <i>About Us</i>
                  </a>{" "}
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                {/* <li>Calculator</li><i class="fa fa-angle-right" aria-hidden="true"></i> */}
                {window.location.pathname != "/AboutUs" ? (
                  <li>{pathname}</li>
                ) : (
                  ""
                )}
              </ul>
              <div className="section-header">
                <h2>Registrar</h2>
              </div>
            </Col>
            <Col sm={12}>
              <div className="about-common-left">
                <h6>KFin Technologies Limited (KFin)</h6>
                <p>
                  Selenium Tower B, Plot No. 31 & 32,Financial District,
                  Nanakramguda, Serilingampally Mandal, Hyderabad – 500 032.
                </p>
              </div>
              <div className="about-common-right">
                <p>
                  As Registrar to the Schemes, KFin will accept and process
                  investor's applications, handle communications with investors,
                  perform data entry services, despatch Account Statements and
                  also perform such other functions as agreed, on an ongoing
                  basis.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Registar;
